import { ConversationTabs } from "../../ConversationTabs";
import { useChatStore } from "@stores/chatStore";
import { useAppSelector } from "@stores/redux/store";
import { SyncOutlined } from "@ant-design/icons";
import styles from "./styles.module.less";

import type { ConversationTabType } from "@constants/conversationTabs";

interface ConversationFiltersProps {
  activeTab: ConversationTabType;
  onTabChange: (tab: ConversationTabType) => void;
}

export const ConversationFilters = ({
  activeTab,
  onTabChange,
}: ConversationFiltersProps) => {
  const isSyncing = useChatStore((state) => state.isSyncing);
  const syncItemsSuccess = useChatStore((state) => state.syncItemsSuccess);
  const selectedFanpageName = useChatStore((state) => state.selectedFanpageName);
  const { pages: facebookPages } = useAppSelector((state) => state.fanpage);
  
  const currentPage = selectedFanpageName
    ? facebookPages.find((page) => page.name === selectedFanpageName)
    : null;

  const isCurrentPageSyncing = isSyncing && currentPage?.messageSyncStatus === "IN_PROGRESS";

  return (
    <>
      <div className={styles.filters}>
        <div className={styles.tabsWrapper}>
          <ConversationTabs activeTab={activeTab} onChange={onTabChange} />
        </div>
      </div>
      {isCurrentPageSyncing && (
        <div className={styles.syncProgressBar}>
          <div className={styles.syncProgressContent}>
            <div className={styles.syncInfo}>
              <SyncOutlined className={styles.syncIcon} spin />
              <span className={styles.syncText}>
                Số cuộc hội thoại đã đồng bộ
                {
                  <span className={styles.syncItemsCount}>
                    {syncItemsSuccess}
                  </span>
                }{" "}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
